import { render } from "./TaskStatusLabel.vue?vue&type=template&id=593e5ed2&scoped=true"
import script from "./TaskStatusLabel.vue?vue&type=script&lang=js"
export * from "./TaskStatusLabel.vue?vue&type=script&lang=js"

import "./TaskStatusLabel.vue?vue&type=style&index=0&id=593e5ed2&scoped=true&lang=scss"

import exportComponent from "/home/tabelka-front/tabelka.expansja.pl/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-593e5ed2"]])

export default __exports__